import type { AuthUser } from "@/types";

export const decodeJwt = (token: string): AuthUser | undefined => {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return undefined;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      globalThis
        .atob(base64)
        .split("")
        .map(
          (character) =>
            `%${(`00${character.charCodeAt(0).toString(16)}`).slice(-2)}`
        )
        .join("")
    );
    const parsed: unknown = JSON.parse(jsonPayload);
    return parsed && typeof parsed === "object" ? (parsed as AuthUser) : undefined;
  } catch {
    return undefined;
  }
};

export const formatDuration = (durationInSeconds: number): string => {
  const duration = Math.floor(durationInSeconds);
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;

  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  return hours > 0
    ? `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    : `${formattedMinutes}:${formattedSeconds}`;
};
